"use client"

import styles from "./pagination-controls.module.css"

export const PaginationControls = ({ currentPage, label, onPageChange, totalPages }: { readonly currentPage: number; readonly label: string; readonly onPageChange: (page: number) => void; readonly totalPages: number }) => {
  if (totalPages <= 1) return null

  return (
    <nav aria-label={label} className={styles["pagination"]} data-pagination>
      <button disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} type="button">
        이전
      </button>
      <span aria-live="polite">
        <strong>{currentPage}</strong> / {totalPages}
      </span>
      <button disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} type="button">
        다음
      </button>
    </nav>
  )
}
